export class DatahubPickerEvent extends CustomEvent {
    constructor(layer) {
        super('changed', {
            detail: layer,
        });
        this.layer = layer;
    }
    getLayer() {
        return this.layer;
    }
}
